<script>
    import {createEventDispatcher} from "svelte";
    import {eventBus} from "../core/event-bus-store.js";
    const dispatch = createEventDispatcher();

    export let record;
    export let publishConfig;
    export let tenantKey;

    const addToCartHandler = (record, priceIdx) => {

        const alreadyAdded = (record?._orderedItems || 0) > 0;
        const hasOptions = record?.prices?.length > 1 || record?.mods?.length > 0;

        if (hasOptions) {
            eventBus.set([{event: 'openEditDetailsHalfScreen', payload: {record, mode: !alreadyAdded ? 'addItems' : 'removeItems'}}]);
        }
        else {
            dispatch('addToCart', {record, priceIdx});
        }
    };

    const toggleFavoriteHandler = (record) => {
        dispatch('toggleFavorite', record);
    };

</script>

<style>
    .record {
        display: flex;
        flex-direction: column;
        gap: 0.125rem;
    }
    .record .content {
        display: flex;
        gap: .4rem;
    }
    .record .title-block {
        flex: 1 1;
        display: flex;
        flex-direction: column;
        gap: .25rem;
    }
    .record .title-block .title {
        display: flex;
        align-items: center;
        font-family: var(--font-1);
        text-transform: uppercase;

        color: var(--title-font-color);
        font-size: 14px;
        line-height: 14px; /* 116.667% */
    }
    .record .title-block .title .fav {
        margin-right: .25rem;
        line-height: 1;
        height: .875rem; /*14px*/
    }
    .record .descr {
        color: var(--descr-font-color);
        font-family: var(--font-2);
        font-size: 12px;
        font-style: normal;
        font-weight: 300;
        line-height: 14px; /* 116.667% */
    }
    .record .allergens ul {
        display: flex;
        gap: .25rem;
    }
    .record .allergens ul li {
        background: var(--allergens-bg-color);
        color: var(--allergens-font-color);
        padding: 0 .25rem;
        border-radius: .1rem;

        font-family: var(--font-2);
        font-size: 10px;
        font-style: normal;
        font-weight: 300;
        line-height: 14px; /* 140% */
        text-transform: capitalize;
    }
    .record .prices {
        display: flex;
        flex-direction: column;
        align-items: end;
        gap: .625rem;
    }
    .record .prices .price-block {
        display: flex;
        justify-content: end;
        align-items: center;
        line-height: 1.4rem;
        gap: .25rem;
        width: 100%;
    }
    .record .prices .price-block .weight {
        color: #C7C7C7;
        text-align: right;
        font-family: var(--font-2);
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: 10px; /* 100% */
    }
    .record .prices .price-block .price-from {
        font-size: 12px;
    }
    .record .prices .price-block .price {
        flex: 1 1;
        color: var(--title-font-color);
        text-align: right;
        font-family: var(--font-2);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 12px; /* 100% */
    }
    .record .prices .price-block .price.price--old {
        text-decoration: line-through;
        font-weight: 100;
        opacity: .7;
    }
    .record .prices .price-block .action {
        line-height: 1;
        display: inline-block;
        height: 1em;

        position: relative;
        padding: 0;
        border: none;
        background: none;
        color: inherit;
        font-size: inherit;
        font-family: inherit;
        transition: transform .1s ease;
    }
    .action--info {
        opacity: .4;
    }
    .record .prices .price-block .action:active {
        transform: scale(1.05);
    }

    @media (min-width: 768px) {
        .record .prices .price-block .action:hover {
            color: var(--price-item-bg-color);
        }
        .record .prices .price-block .action {
            cursor: pointer;
        }
    }

    .record .label {
        background: var(--label-bg-color);
        color: var(--label-font-color);
        border-radius: .1rem;
        padding: 0 .24rem;
        font-size: 10px;
        line-height: 14px;
        text-transform: capitalize;
        display: inline-block;
        margin-bottom: .1rem;
    }

    .counter-badge {
        position: absolute;
        top: -6px;
        right: -6px;
        background: #47C034;
        border-radius: 50%;
        width: 1.2em;
        height: 1.2em;
        line-height: 1.2em;
        color: white;
        text-align: center;
        font-family: var(--font-2);
        font-size: .5rem;
    }
</style>

<div class="record">

    {#if (record.label)}
        <div>
            <span class="label">{ record.label }</span>
        </div>
    {/if}

    <div class="content">

        <div class="title-block">
            <div class="title wrap-anywhere">

                {#if record.isFavorite}
                    <div class="fav" on:click={() => toggleFavoriteHandler(record)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Heart"><path d="M7 3C4.239 3 2 5.216 2 7.95c0 2.207.875 7.445 9.488 12.74a.985.985 0 0 0 1.024 0C21.125 15.395 22 10.157 22 7.95 22 5.216 19.761 3 17 3s-5 3-5 3-2.239-3-5-3z"/></svg>
                    </div>
                {/if}

                <span on:click={() => toggleFavoriteHandler(record)}>{ record.name || '' }</span>
            </div>

            <div class="descr wrap-anywhere">
                {#if (!record._found_desc)}
                    {record.description || ''}
                {:else}
                    {@html record._found_desc}
                {/if}
            </div>

            {#if (record.allergens && record.allergens.length > 0)}
                <div class="allergens">
                    <ul>
                        {#each record.allergens as allergens}
                            <li>{ allergens }</li>
                        {/each}
                    </ul>
                </div>
            {/if}
        </div>

        <div class="prices">
            {#each record.prices as price, priceIdx }
                <div class="price-block">

                    <span>
                        <span class="weight">{ price.weight || '' }</span>

                        {#if (price.oldPrice)}
                            <span class="price price--old">{ price.oldPrice }</span>
                        {/if}

                        <!-- PRICE -->
                        <span class="price nowrap">
                            {#if (record.mods?.length > 0)}
                                <span class="price-from">от</span>
                            {/if}
                            { price.price }&nbsp;{ publishConfig?.currency || ''}
                        </span>
                    </span>

                    <!-- ADD -->
                    {#if (publishConfig.disableCart !== true)}
                        {#if ((price._count || 0) === 0)}
                            <button class="action">
                                <span on:click={() => addToCartHandler(record, priceIdx)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-CirclePlus"><path d="M12 8v4m0 0v4m0-4h4m-4 0H8"/><circle cx="12" cy="12" r="10"/></svg>
                                </span>
                            </button>
                        {/if}

                        {#if ((price._count || 0) !== 0)}
                            <button class="action">
                                <span class="counter-badge bounce-animation">{record._orderedItems}</span>
                                <span on:click={() => addToCartHandler(record, priceIdx)}>
                                    <svg width="1em" height="1em" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 8.00002C13 4.91669 10.662 2.37269 7.66668 2.03935V0.666687H6.33334V2.03935C3.33801 2.37269 1.00001 4.91669 1.00001 8.00002V9.33335H13V8.00002ZM2.33334 8.00002C2.33334 5.42735 4.42734 3.33335 7.00001 3.33335C9.57268 3.33335 11.6667 5.42735 11.6667 8.00002H2.33334ZM0.333344 10H13.6667V11.3334H0.333344V10Z" fill="#47C034"/></svg>
                                </span>
                            </button>
                        {/if}
                    {/if}

                    <!-- INFO -->
                    {#if (publishConfig.disableCart === true && record.mods?.length > 0)}
                        <button class="action action--info">
                            <span on:click={() => addToCartHandler(record, priceIdx)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Info"><circle cx="12" cy="12" r="10"/><path d="M12 7h.01"/><path d="M10 11h2v5"/><path d="M10 16h4"/></svg>
                            </span>
                        </button>
                    {/if}

                </div>
            {/each}
        </div>
    </div>
</div>
